'use client';

import {
  StoneFAQSection,
  StoneInvestmentServicesSection,
  StoneInvestmentTheFirmSection,
} from '@routeroyal/theme-stone-investment';

type Props = {
  locale: string;
  messages: Record<string, unknown>;
  propertyImages?: string[];
};

/**
 * Stone Investment About/The Firm Content
 * 
 * Uses the Concept One "The Firm" design with:
 * - Editorial hero with title and subtitle
 * - Founders section with photos and bios
 * - Philosophy split layout
 * - Tenets grid
 * - Our Expertise services bento grid
 */
export function AboutContentStone({ locale, messages, propertyImages }: Props) {
  const stoneMessages = (messages?.stone || {}) as Record<string, unknown>;
  const aboutMessages = (stoneMessages?.about || {}) as Record<string, string>;
  const servicesSectionMessages = (stoneMessages?.servicesSection || {}) as Record<string, unknown>;

  const translatedServices = (servicesSectionMessages?.services as Array<{ id: string; title: string; description: string }>) || [
    {
      id: 'prestige',
      title: 'Prestige Property Sales',
      description: 'Exceptional properties including character houses, vineyards, sea front villas, and luxury apartments.',
    },
    {
      id: 'valuations',
      title: 'Property Valuations',
      description: 'Expert valuation services with deep knowledge of local markets and property characteristics.',
    },
    {
      id: 'mauritius',
      title: 'Mauritius Investment',
      description: 'Specialized expertise in Mauritius real estate including IRS, RES, PDS, R+2, and Smart City schemes with full legal and financial guidance.',
    },
    {
      id: 'architecture',
      title: 'Architectural Properties',
      description: 'Curated selection of iconic 20th century architectural movements and historically significant properties.',
    },
  ];

  return (
    <>
      <StoneInvestmentTheFirmSection
        locale={locale}
        messages={messages}
        {...(propertyImages ? { propertyImages } : {})}
      />

      <StoneInvestmentServicesSection
        title={aboutMessages?.expertiseTitle || (servicesSectionMessages?.eyebrow as string) || 'Our Expertise'}
        subtitle={aboutMessages?.expertiseSubtitle || 'Comprehensive services for discerning property seekers'}
        services={translatedServices}
        layout="bento"
        messages={messages}
      />

      <StoneFAQSection
        source="about"
        locale={locale}
        messages={messages}
        className="bg-stone-50"
      />
    </>
  );
}
